import { PayMCopyDateStatusKeys } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import useTwinTranslation from '../useTwinTranslation'
import { TwinIconProp } from '../../../baseComponents/TwinIcon'
import { faClock, faFileCheck, faFileSlash, faLayerGroup, faPencil, faShare, faSplit } from '@fortawesome/pro-light-svg-icons'

interface CollectionAndPaymentStatusTy {
    name: string
    colorText: string
    icon: TwinIconProp
}
const useCollectionAndPaymentStatus = () => {
    const { t } = useTwinTranslation()
    const collectionAndPaymentStatus: Record<PayMCopyDateStatusKeys, CollectionAndPaymentStatusTy> = {
        0: { name: t('eraser', 'Borrador'), colorText: 'text-gray-2E', icon: faPencil },
        1: { name: t('notProcessed', 'Sin procesar'), colorText: 'text-gray-2E', icon: faClock },
        2: { name: t('pendingPaymentShort', 'Pago Pend.'), colorText: 'text-yellow-B9', icon: faShare },
        3: { name: t('paid', 'Pagado'), colorText: 'text-green-21', icon: faFileCheck },
        4: { name: t('canceled', 'Cancelado'), colorText: 'text-red-BA', icon: faFileSlash },
        5: { name: t('notPayed', 'Impagado'), colorText: 'text-red-BA', icon: faFileSlash },
        6: { name: t('grouped', 'Agrupado'), colorText: 'text-yellow-B9', icon: faLayerGroup },
        7: { name: t('divided', 'Dividido'), colorText: 'text-yellow-B9', icon: faSplit },
    }

    return { collectionAndPaymentStatus }
}

export default useCollectionAndPaymentStatus